import React from 'react';
import InputLabel from '../InputLabel';
import InputError from '../InputError';
import InputSuccess from '../InputSuccess';


import './Input.css';

export default function Input({ onChange, label, info, containerStyle, className, labelClassName, error, success, isnumeric, allowspaces, isphone, disabled, placeholder, ...rest })
{
    const handleInput = (e)=>{
        if( isnumeric )
            e.target.value = e.target.value.replace(/[^0-9]/g, '');
        
        if( allowspaces === false )
            e.target.value = e.target.value.replace(/ /g, '');

        if( isphone )
            e.target.value = e.target.value.replace(/\+/g, '');

        return onChange(e);
    }

    return (
        <div className="input-container" style={containerStyle}>
            { label ? <InputLabel label={label} info={info} className={labelClassName}/> : null }
            <div className="input-content">
                <input 
                    {...rest}
                    disabled={disabled}
                    placeholder={placeholder}
                    title={placeholder || label || info || ''} 
                    className={'input ' + (error ? ' error ' : '') + (className || '')} 
                    onChange={handleInput}
                />
            </div>
                
            { error ? <InputError error={error}/> : null }
            { success ? <InputSuccess message={success}/> : null }
        </div>
    ) 
}